import { Outlet } from "react-router-dom";
import { PlayLayout } from "common/layouts/PlayLayout";
// import { MOBILE_PURPLE_BACKGROUND } from "../../../_graphic_design";
import type { Event } from "../../types/event.model";
import { useEvent } from "../../hooks/useEvent";

const EventPlayThemeWrapper = () => {
  const event: Event | undefined = useEvent();
  const backGroundDesktopUrl = event?.images?.eventMobileBackground || "";

  const defaultTheme = {
    colors: {
      background: event?.colors.eventBackgroundColor || "#06031C",
      text: "#000000",
    },
    images: {
      playBackground: backGroundDesktopUrl,
    },
    position: event?.images?.backGroundPosition,

    ...(event?.font && { font: { fontFace: event.font } }),
  };

  console.log("FONT", event?.font);

  console.log("THEME", defaultTheme);

  return (
    <PlayLayout theme={defaultTheme}>
      <Outlet />
    </PlayLayout>
  );
};

export { EventPlayThemeWrapper };
